import { Card, CardContent, Typography, Container } from '@mui/material'
import { ClearAll, Search } from '@mui/icons-material'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { useTheme } from '@emotion/react';
// import FormLogin from '../Patient/FormLogin';
import FormSearch from './FormSearch';
import FormSearchImagenologia from './FormSearchImagenologia';
import FormSearchProcedimiento from './FormSearchProcedimiento';
// import FormGuest from '../Patient/FormReservationGuest';
//import { useRecoilState, useRecoilValue } from 'recoil';
import { useRecoilCallback, useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
//import { activeTabReservationState } from './state/atoms';
import { activeTabState } from './state/atoms';
//import { valuesFormReservationGuestState, valuesFormReservationUserState } from 'src/Patient/state/atoms';
import React, { useState , useEffect} from 'react';

import { useNavigate } from 'react-router-dom';

import TabsCustom from 'src/shared/components/tabs/TabsCustom';
import ButtonCustom from '../shared/components/buttons/ButtonCustom'
import { filterSearchSelectedState, hoursAvailableState, professionalsMatchCovenantState, professionalsNoMatchCovenantState } from './state/atoms'
import useSEO from 'src/Hooks/useSEO'
import ReactGA from "react-ga4";
import { covenantsFetchState, covenantsState, professionalsBySpecialityState, professionalsState, serviciosState, specialitiesFetchState, specialitiesState, sucursalesFetchState, sucursalesState, tipoExamenState } from './components/autocompletes/state/atoms';
import TipoExamenService from 'src/services/agenda/tipoExamen';
import procedimientoService from 'src/services/agenda/procedimientos';
import useLoadData from './hooks/useLoadData';

export default function TabsSearch() {
  const [loading, setLoading] = useState(false)
  //const history = useNavigate();
  const navigate = useNavigate();


  const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);
  const theme = useTheme()
  //const valuesFormReservationGuest = useRecoilValue(valuesFormReservationGuestState);
  //const valuesFormReservationUser = useRecoilValue(valuesFormReservationUserState)

  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const resetFilterSearchSelected = useResetRecoilState(filterSearchSelectedState);
  //const setPreloader = useSetRecoilState(preloaderState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(professionalsMatchCovenantState);
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(professionalsNoMatchCovenantState);
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const { loadData, loadingData } = useLoadData();

  const [tabsDisabled, setTabsDisabled] = useState({
    one: false,
    two: false
  });

  const handleChangeTab = (event, newValue) => {
    resetFilterSearchSelected();
    setActiveTabSearch(newValue);
  };

  const eventGA = () => {
    console.log("Evento Google Analytics -> Buscar");
    let especialidad = filterSearchSelected.specialitySelected.value;
    especialidad = especialidad != "" ? `Especialidad: ${especialidad}` : "";
    let profesional = filterSearchSelected.professionalSelected.value;
    profesional = profesional != "" ? `| Profesional: ${profesional}` : "";
    let prevision = filterSearchSelected.covenantSelected.value;
    prevision = prevision != "" ? `| Previsión: ${prevision}` : "";
    console.log(`${especialidad} ${profesional} ${prevision}`);
    ReactGA.event({
      category: 'Buscar',
      action: `${especialidad} ${profesional} ${prevision}`
    });
  }

  const eventImagenologiaGA = () => {
    console.log("Evento Google Analytics -> Buscar Imagenologia");
    let tipoExamen = filterSearchSelected.tipoExamenSelected.value;
    tipoExamen = tipoExamen != "" ? `TipoExamen: ${tipoExamen}` : "";
    let examen = filterSearchSelected.examenSelected.value;
    examen = examen != "" ? `| Examen: ${examen}` : "";
    console.log(` ${tipoExamen} ${examen} `);
    ReactGA.event({
      category: 'Buscar',
      action: `${tipoExamen} ${examen}`
    });
  }

  return (
    <Box sx={{ width: '100%', typography: 'body1' }} style={{
      marginTop: "1rem",
    }}>
      <TabContext value={activeTabSearch} >
        <Box >
          <TabsCustom 
            theme={theme} 
            onChange={handleChangeTab} 
            aria-label="lab API tabs example" 
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile 
          >
            <Tab label="HORA MÉDICA" value="1" disabled={tabsDisabled["one"]} />
            <Tab label="IMAGENOLOGÍA" value="2" disabled={tabsDisabled["two"]} />
            <Tab label="PROCEDIMIENTOS" value="3" disabled={tabsDisabled["tree"]} />
          </TabsCustom>
        </Box>
        <TabPanel value="1" className='formularioNuevo' style={{
          padding: "0px",
        }}
        >
          {/* <FormLogin xs={12} sm={6} /> */}
          <Card style={{
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}>
            <CardContent>
              <FormSearch />
            </CardContent>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2,
              }}
            >
              <ButtonCustom
                disabled={filterSearchSelected.professionalSelected.value === '' && filterSearchSelected.specialitySelected.value === '' ? true : false}
                loading={loading}
                color="secondary"
                text="BUSCAR"
                icon={<Search />}
                style={{ marginRight: 15 }}
                onClick={() => {
                  setLoading(true);
                  resetProfessionalsMatchCovenant();
                  resetProfessionalsNoMatchCovenant();
                  resetHoursAvailable();
                  eventGA();
                  setTimeout(() => {
                    //history.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`);
                    navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda`);
                  }, 1000)
                }}
              />
              <ButtonCustom
                color="default"
                variant="contained"
                text="LIMPIAR"
                icon={<ClearAll />}
                onClick={()=>{
                  resetFilterSearchSelected();
                  loadData(1);
                }}
              />
            </Box>
          </Card>
        </TabPanel>
        <TabPanel value="2" style={{
          padding: "0px",
        }}>
 
          <Card style={{
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}>
            <CardContent>
              <FormSearchImagenologia />
            </CardContent>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2,
              }}
            >
              <ButtonCustom
                disabled={filterSearchSelected.examenSelected.value === '' ? true : false}
                loading={loading}
                color="secondary"
                text="BUSCAR"
                icon={<Search />}
                style={{ marginRight: 15 }}
                onClick={() => {
                  setLoading(true);
                  resetProfessionalsMatchCovenant();
                  resetProfessionalsNoMatchCovenant();
                  resetHoursAvailable();
                  eventImagenologiaGA();
                  setTimeout(() => {
                    //history.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`);
                    navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`);
                  }, 1000)
                }}
              />
              <ButtonCustom
                color="default"
                variant="contained"
                text="LIMPIAR"
                icon={<ClearAll />}
                onClick={()=>{
                  resetFilterSearchSelected();
                  loadData(2);
                }}
              />
            </Box>
          </Card>
        </TabPanel>
        <TabPanel value="3" style={{
          padding: "0px",
        }}>
 
          <Card style={{
            borderTopLeftRadius: "0px",
            borderTopRightRadius: "0px",
          }}>
            <CardContent>
              <FormSearchProcedimiento />
            </CardContent>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2,
              }}
            >
              <ButtonCustom
                disabled={filterSearchSelected.procedimientoSelected.value === '' ? true : false}
                loading={loading}
                color="secondary"
                text="BUSCAR"
                icon={<Search />}
                style={{ marginRight: 15 }}
                onClick={() => {
                  setLoading(true);
                  resetProfessionalsMatchCovenant();
                  resetProfessionalsNoMatchCovenant();
                  resetHoursAvailable();
                  //eventImagenologiaGA();
                  setTimeout(() => {
                    //history.push(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-imagenologia`);
                    navigate(`${process.env.REACT_APP_ROOT_SERVER_PATH}/resultado-busqueda-procedimiento`);
                  }, 1000)
                }}
              />
              <ButtonCustom
                color="default"
                variant="contained"
                text="LIMPIAR"
                icon={<ClearAll />}
                onClick={()=>{
                  resetFilterSearchSelected();
                  loadData(3);
                }}
              />
            </Box>
          </Card>
        </TabPanel>        
      </TabContext>
    </Box>
  );
}
